import React, { Fragment } from "react";
import CooperativesDetailWorkersTable from "containers/cooperativesDetailWorkersTable";
export default function() {
  return (
    <Fragment>
      <CooperativesDetailWorkersTable />      
    </Fragment>
  );
}
